export default "__VITE_ASSET__CaB0apKZ__"